import { getColor } from '../utils';

import { SvgIcon, SvgIconProps } from '../SvgIcon';

export const HostedUnsubscribe = ({
  height = 24,
  width = 24,
  color = 'currentColor',
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon width={width} height={height} viewBox="0 0 24 24" {...props}>
    <g clipPath="url(#clip0_3130_49605)">
      <path
        d="M17.4375 9.75H6.5625C6.25184 9.75 6 10.0018 6 10.3125V11.8125C6 12.1232 6.25184 12.375 6.5625 12.375H17.4375C17.7482 12.375 18 12.1232 18 11.8125V10.3125C18 10.0018 17.7482 9.75 17.4375 9.75Z"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.1875 14.625H6.5625C6.25184 14.625 6 14.8768 6 15.1875V16.6875C6 16.9982 6.25184 17.25 6.5625 17.25H9.1875C9.49816 17.25 9.75 16.9982 9.75 16.6875V15.1875C9.75 14.8768 9.49816 14.625 9.1875 14.625Z"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 14.625H18"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 17.25H18"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M19.3125 4.5H4.6875C4.06618 4.5 3.5625 5.00368 3.5625 5.625V18.375C3.5625 18.9963 4.06618 19.5 4.6875 19.5H19.3125C19.9338 19.5 20.4375 18.9963 20.4375 18.375V5.625C20.4375 5.00368 19.9338 4.5 19.3125 4.5Z"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.5625 7.875H20.4375"
        stroke={getColor(color, isColorInherited)}
        strokeWidth="1.25"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <clipPath id="clip0_3130_49605">
        <rect width="18" height="18" fill="white" transform="translate(3 3)" />
      </clipPath>
    </defs>
  </SvgIcon>
);
